<script setup lang="ts">
import type { IconType } from './IconType'
import type { Color } from './TextCommon'

const {
  type,
  size = 24,
  color = 'neutral-default',
  rotate90 = false,
} = defineProps<{
  type: IconType
  size?: number
  color?: Color
  rotate90?: boolean
}>()

const Icon = defineAsyncComponent(() => import(`~/assets/images/icons/${type}.svg`))
</script>

<template>
  <div class="icon-wrapper" :class="{ 'rotate-90': rotate90 }">
    <Icon class="icon" :class="{ [color]: true }" />
  </div>
</template>

<style scoped lang="scss">
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(v-bind(size) * 1px);
  height: calc(v-bind(size) * 1px);
}

.rotate-90 {
  transform: rotate(-90deg);
}

.icon {
  width: calc(v-bind(size) * 1px);
  height: calc(v-bind(size) * 1px);
}

.brand-strong {
  fill: var(--semantic-tokens-brand-strong-text);
}

.success-strong {
  fill: var(--semantic-tokens-success-strong-text);
}

.success-default {
  fill: var(--semantic-tokens-success-default-text);
}

.danger-strong {
  fill: var(--semantic-tokens-danger-default-text);
}

.attention-strong {
  fill: var(--semantic-tokens-attention-strong-text);
}

.attention-default {
  fill: var(--semantic-tokens-attention-default-text);
}

.attention-secondary-default {
  fill: var(--semantic-tokens-attention-secondary-default-text);
}

.neutral-default {
  fill: var(--semantic-tokens-neutral-default-text);
}

.neutral-weak {
  fill: var(--semantic-tokens-neutral-weak-text);
}

.neutral-x-weak {
  fill: var(--semantic-tokens-neutral-xweak-text);
}

.inverse-default {
  fill: var(--semantic-tokens-inverse-default-text);
}

.link-default {
  fill: var(--semantic-tokens-link-default-text);
}
</style>
